export default __webpack_public_path__ + "static/media/road_safety_training.6ca42bb9.jpg";